/**
 * /app/$tenantSlug/accounting/sales/quotes — Books → Sales → Quotes.
 *
 * Sales has two top-bar tabs, Invoices (/accounting/sales) and Quotes
 * (this page), like the other Books modules (lib/surfaces.ts
 * "run:books-sales"). The old ?tab=quotes link on /accounting/sales
 * redirects here.
 */

import { createFileRoute, Link, useParams } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { AccountingModuleShell } from "@/components/shared/accounting-module-shell";
import { QuoteList } from "@/components/accounting/quote-list";
import { Button } from "@/components/ui/button";
import { accountingKeys } from "@/hooks/use-accounting";
import { accountingApi } from "@/lib/api";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/accounting/sales/quotes/")({
  // A9 hover-prefetch: the unfiltered list QuoteList starts with.
  loader: ({ context }) =>
    context.queryClient
      .ensureQueryData({
        queryKey: accountingKeys.quotes(undefined),
        queryFn: ({ signal }) => accountingApi.listQuotes(undefined, signal),
      })
      .catch(() => undefined),
  component: SalesQuotesRoute,
});

function SalesQuotesRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  return (
    <AccountingModuleShell
      title="Quotes"
      description="Quotes for your customers. Turn an accepted quote into an invoice."
      actions={
        <Button asChild className="gap-1.5">
          <Link to="/app/$tenantSlug/accounting/sales/quotes/new" params={{ tenantSlug }}>
            <Plus aria-hidden className="h-4 w-4" />
            New Quote
          </Link>
        </Button>
      }
    >
      <QuoteList />
    </AccountingModuleShell>
  );
}
